var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01727 -6.13459e-07C7.26879 -5.91471e-07 7.52028 0.0960368 7.71205 0.287709L13.7465 6.32224C14.1304 6.70612 14.1304 7.3285 13.7465 7.71221C13.3628 8.09593 12.7405 8.09593 12.3566 7.71221L7.01727 2.37252L1.67786 7.71203C1.29398 8.09574 0.671789 8.09574 0.288104 7.71203C-0.0959529 7.32831 -0.0959529 6.70593 0.288104 6.32206L6.32248 0.287522C6.51434 0.0958193 6.76584 -6.3544e-07 7.01727 -6.13459e-07Z",
    fill: "#3CB4E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.ffeea463f8c4778c9472999eadeb979e.svg";
export { ForwardRef as ReactComponent };